import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetOrderInvoiceEmailDraftQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
  docType?: Types.InputMaybe<Types.OrderEmailDocType>;
}>;


export type GetOrderInvoiceEmailDraftQuery = { __typename?: 'Query', orderInvoiceEmailDraft?: { __typename?: 'OrderInvoiceEmailDraftData', recipients: Array<string>, emailSubject: string, emailBody: string, reportId?: string | null, docType: Types.OrderEmailDocType, sender: { __typename?: 'TenantEmailSenderData', senderId: string, email: string, displayName: string, isDefault: boolean, isPlatformDefault: boolean } } | null };


export const GetOrderInvoiceEmailDraftDocument = new TypedDocumentString(`
    query GetOrderInvoiceEmailDraft($orderId: String!, $docType: OrderEmailDocType) {
  orderInvoiceEmailDraft(orderId: $orderId, docType: $docType) {
    recipients
    emailSubject
    emailBody
    reportId
    docType
    sender {
      senderId
      email
      displayName
      isDefault
      isPlatformDefault
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetOrderInvoiceEmailDraft: build.query<GetOrderInvoiceEmailDraftQuery, GetOrderInvoiceEmailDraftQueryVariables>({
      query: (variables) => ({ document: GetOrderInvoiceEmailDraftDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetOrderInvoiceEmailDraftQuery, useLazyGetOrderInvoiceEmailDraftQuery } = injectedRtkApi;
